<template>
  <div v-if="signupBannerVisible" class="loyalty">
    <AW23TextCard :title="text">
      <template #cta>
        <Button
          form="underline"
          @click="setSlideSignUp({ value: true, forceShow: true })"
        >
          Create Account
        </Button>
        <Button form="underline" @click="setSlideLogin(true)">Sign In</Button>
      </template>
    </AW23TextCard>
  </div>
  <FooterLinks />
  <SlideLogin />
  <StoreRedirect v-if="!isPlaywright" />
  <footer class="footer">
    <div class="footer-grid">
      <div class="footer-grid__copyright">
        <p class="copyright">&copy;2024 RAT &AMP; BOA</p>
      </div>
      <div class="footer-grid__logo">
        <a href="/">
          <img
            class="footer__logo"
            src="https://cdn.shopify.com/s/files/1/0942/9062/files/monogram.svg?v=1652005246"
            width="82"
            height="66"
          />
        </a>
      </div>
      <div class="footer-grid__links">
        <ul class="links">
          <li>
            <Currency
              :options="dropdownoptions"
              theme="secondary"
              :selected="currencyCode"
              title="Currency"
              form="transparent"
              class="currency-dropdown"
              direction="up"
              @changed="handleCurrencyChange"
            />
          </li>
          <li>
            <Button
              form="underline-invert"
              class="link"
              tag="a"
              href="/pages/terms-conditions"
              theme="secondary"
            >
              Terms &amp; Conditions
            </Button>
          </li>
          <li>
            <Button
              form="underline-invert"
              class="link"
              tag="a"
              href="/pages/privacy-policy"
              theme="secondary"
            >
              Privacy
            </Button>
          </li>
          <li>
            <Button
              form="underline-invert"
              class="link"
              tag="a"
              href="/pages/members-terms-conditions"
              theme="secondary"
            >
              Member Terms
            </Button>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import FooterLinks from "@/components/FooterLinks.vue";
import SlideLogin from "@/components/SlideLogin.vue";
import StoreRedirect from "@/components/StoreRedirect.vue";
import DropDown from "@/components/DropDown.vue";
import Button from "@/components/ButtonV2.vue";
import AW23TextCard from "@/components/homepage/AW23TextCard.vue";
import { mapActions, mapGetters } from "vuex";
import { signUpBonus } from "@/config";
import { getFeatureToggles } from "@/helpers/featureToggles.js";

export default {
  name: "FooterComponent",
  components: {
    Currency: DropDown,
    FooterLinks,
    SlideLogin,
    StoreRedirect,
    Button,
    AW23TextCard,
  },
  inject: ["isPlaywright"],
  data() {
    return {
      isVisible: true,
      dropdownoptions: [
        {
          value: "gbp",
          label: "GBP (£)",
        },
        {
          value: "eur",
          label: "EUR (€)",
        },
        {
          value: "usd",
          label: "USD ($)",
        },
        {
          value: "aud",
          label: "AUD ($)",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("app", ["currencyCode"]),
    signupBannerVisible() {
      return !this.isLoggedIn;
    },
    bonus() {
      if (!this.currencyCode) {
        return null;
      }
      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
    text() {
      if (this.version === 5) {
        return "Create a Members Only account now";
      }
      return `Sign up & create a Members Only account to receive a ${this.bonus} discount for your first order`;
    },
    version() {
      const { dataCollectionVersion = 3 } = getFeatureToggles();
      return dataCollectionVersion;
    },
  },
  methods: {
    ...mapActions("app", ["setSlideLogin", "setSlideSignUp", "changeCurrency"]),
    handleCurrencyChange(value) {
      this.changeCurrency(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  &__logo {
    width: 56px;
  }
}

.footer-grid {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;

  @include respond-above(md) {
    padding: 0 24px;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 20px;

    &__copyright,
    &__links {
      flex: 1;
    }
  }

  &__copyright {
    background-color: $color-grey-light;
    order: 3;
    text-align: center;
    padding-bottom: 24px;

    @include respond-above(md) {
      padding-bottom: 0;
      order: 1;
      text-align: left;
      background-color: transparent;
    }
  }

  &__logo {
    padding-top: 5px;
    order: 2;
    text-align: center;
    background-color: $color-grey-light;
    flex: 1 0 auto;

    @include respond-above(md) {
      padding-top: 0px;
      order: 2;
      flex: 0 0 auto;
      background-color: transparent;
    }
  }

  &__links {
    padding: 20px;
    order: 1;

    @include respond-above(md) {
      padding: 20px 0;
      order: 3;
      display: block;
    }
  }
}

.copyright {
  @include utility-label(10px);
  color: $color-grey-dark;

  @include respond-above(md) {
    @include utility-label(12px);
  }
}

.currency-dropdown {
  :deep() {
    .button {
      padding: 0;
      background: transparent;
      border: none;
      color: $color-grey-dark;

      @include respond-above(md) {
        padding-right: 14px;
      }
    }

    .button .text {
      @include utility-label(12px);
    }
  }
}

.links {
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  align-items: stretch;
  flex-direction: column;

  @include respond-above(md) {
    gap: 24px;
    flex-direction: row;
    align-items: center;
  }
}

.link {
  @include utility-label(12px);
}

.loyalty {
  background: $color-grey-light;
  display: flex;
  justify-content: center;
}
</style>
